import { Icon, Button } from 'antd';

export default class NoEndorsementData extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div>
                <div className='provider-endorsements-loading-container'>
                    <Icon 
                        type='info-cirlce' 
                        style={{ fontSize: '20px' }}
                    />
                    <span className='provider-endorsements-loading'>
                        {'No record(s)'}
                    </span>
                </div>
            </div>
        );
    }
}